<div
  class="checkbox"
  #checkbox
  role="checkbox"
  tabindex="0"
  [attr.aria-checked]="checked"
  [attr.aria-disabled]="checkboxData['offerCount'] == 0"
  [attr.aria-labelledby]="labelId"
  (click)="selectBox(checkbox, checkboxData.value)"
  (keydown)="onKeydown($event, checkbox)"
  [ngClass]="{
    disabled: checkboxData['offerCount'] == 0,
    selected: checked === true,
    default: checkboxData['value'] === 0
  }"
>
  <div class="checkbox__box" aria-hidden="true"></div>
  <div
    class="checkbox__value-default"
    *ngIf="checkboxData['value'] === 0"
    aria-hidden="true"
  ></div>
  <div class="checkbox__value" *ngIf="checkboxData['value'] !== 0">
    <p class="value__main" [id]="labelId">
      {{ checkboxData.name }}
      <span
        class="value__sub"
        *ngIf="
          checkboxData['offerCount'] &&
          checkboxData['offerCount'] != 0 &&
          checkboxData['rateMin'] != 0
        "
      >
        ab {{ currencyFormatter(checkboxData["rateMin"]) }} mtl.
      </span>
    </p>
  </div>
  <p
    class="checkbox__number"
    *ngIf="checkboxData['offerCount'] != 0"
    aria-hidden="true"
  >
    {{ checkboxData["offerCount"] }}
  </p>
</div>
